module.exports = __webpack_public_path__ + "static/Juxtapose-Snow-Camp-7d51fdbfd7656adf90b678f79a0ca3d6.png";